/* RovoSearchInputSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu88HPE%7Bgap%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3SamIHNHnM%7Bmargin-block%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3TGfC9HnLE%7Bflex-wrap%3Awrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { LoadingSkeleton } from '@townsquare/loading-skeleton';
const styles = {
  input: "_39xV02N91d",
  filters: "_2mHwu88HPE _3SamIHNHnM _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _37wbyuDIqT"
};
export const RovoSearchInputSkeleton = (): React.JSX.Element => <>
		<Box xcss={styles.input} testId="rovo-search-input-skeleton">
			<LoadingSkeleton width="100%" height="56px" borderRadius="16px" />
		</Box>
		<Box xcss={styles.filters} testId="rovo-search-filters-skeleton">
			{[48, 128, 96, 108, 80, 64].map(width => <LoadingSkeleton key={width} width={`${width}px`} height="32px" />)}
		</Box>
	</>;